import React from 'react';

import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import './ExitCourseButton.scss';

export function ExitCourseButton(props: { onClick: () => void; title: React.ReactNode }) {
  return (
    <span className="exit-course" onClick={props.onClick}>
      <FontAwesomeIcon icon={regular('times')} size="lg" fixedWidth /> {props.title}
    </span>
  );
}
